import React from 'react';
import { withTranslation } from 'react-i18next';
import { useAPIError } from '../../../context/useApiError';
import { ModalBlock } from '../..';
import APIErrorCard from './APIErrorCard';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

const APIError = (props) => {
    const { t } = props;
    const { error, removeError } = useAPIError();

    return (
        <ErrorBoundary>
            <ModalBlock
                openingCondition={!!error}
                modalTitle={t('errorAPI.title')}
                closeWithAction={removeError}
                blockWidth="lg"
                hasCloseCross={false}
                style={{zIndex:"500"}} // to guarantee that the modal will be at highest layer and visible
            >
                <APIErrorCard
                    message={error && error.message}
                    status={error && error.status}
                />
            </ModalBlock>
        </ErrorBoundary>
    );
};

export default withTranslation('common')(APIError);
